import script from "./VocabularyView.vue?vue&type=script&setup=true&lang=js"
export * from "./VocabularyView.vue?vue&type=script&setup=true&lang=js"

import "./VocabularyView.vue?vue&type=style&index=0&id=519f3f2f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-519f3f2f"]])

export default __exports__